export enum PosthogFeatureFlag {
  CUSTOMER_EVIDENCE_ENABLED = 'customer_evidence_enabled',
  BROKER_PORTAL_COMMUNICATION_TAB_ENABLED = 'broker-portal-communication-tab-enabled',
  TASKS_SYSTEM = 'tasks_system',
  BROKER_ONBOARDING_NEW_FLOW = 'broker-onboarding-new-flow',
}
